import {
  USER_CHANGED_MODAL_OPEN,
  USER_CHANGED_MODAL_CLOSE,
} from 'src/store/constants';

const initialState = {
  visible: false,
};

const userChangedModal = (state = initialState, action) => {
  switch (action.type) {
    case USER_CHANGED_MODAL_OPEN:
      return {
        ...initialState,
        visible: true,
      };
    case USER_CHANGED_MODAL_CLOSE:
      return {
        ...initialState,
        visible: false,
      };
    default:
      return state;
  }
};

export default userChangedModal;
